<template>
  <div>
    <div class="manuel-report form-group">
      <div class="report-item">
        <base-select
          id="ddlYears"
          :options="years"
          fieldLabel="Yıl"
          placeholder="Yıl Seçiniz"
          :clearable="false"
          v-model="formItems.year"
          :selected-id="formItems.year"
        />
      </div>
      <div class="report-item">
        <base-select
          id="ddlMonths"
          :options="months"
          fieldLabel="Ay"
          placeholder="Ay Seçiniz"
          :clearable="false"
          v-model="formItems.month"
          :selected-id="formItems.month"
        />
      </div>
      <div class="report-item button-container">
        <base-button
          type="submit"
          :class="[stopOverClicks ? 'no-click' : '', 'create-btn']"
          @click="getCustomerReports"
          ><span v-if="!stopOverClicks"> Müşteri Raporu Oluştur </span>
          <span v-else> Rapor oluşturuluyor... </span>
        </base-button>
      </div>
      <div class="report-item button-container">
        <base-button
          type="submit"
          @click="getVdsReports"
          :class="[stopOverClicks ? 'no-click' : '', 'create-btn']"
          >VDS Raporu Oluştur</base-button
        >
      </div>
    </div>
    <div class="manuel-report form-group">
      <div class="report-item base-form-input">
        <date-picker
          v-model="formItems.dateTime"
          id="dateFilter"
          valueType="format"
          placeholder="Tarih Seçiniz"
          range
        ></date-picker>
      </div>

      <div class="report-item button-container">
        <base-button
          type="button"
          :class="[stopOverClicks ? 'no-click' : '', 'create-btn']"
          @click="postAlgorithmExportExcel"
          >Bireysel Terminal Raporu Oluştur</base-button
        >
      </div>
    </div>

    <div class="manuel-report form-group pb-0">
      <h3>Oluşturulan Raporlar</h3>
    </div>
    <div class="manuel-report form-group report-list">
      <list-view-skeleton v-if="logsLoader" :line-count="10" />
      <template v-else>
        <div class="countdown-container">
          <span>Liste {{ countdown }} saniye içinde yenilenecek</span>
        </div>
        <table class="table" aria-describedby="logs">
          <thead>
            <th v-for="item in tableHeaders" :key="item.name">
              <span>{{ item.name }}</span>
            </th>
          </thead>
          <tbody>
            <tr v-for="item in reportListData" :key="item.fileName">
              <td v-if="item.fileName">{{ item.fileName }}</td>
              <td v-else>-</td>
              <td v-if="item.fileLength">{{ item.fileLength }}-mb</td>
              <td v-else>-</td>
              <td v-if="item.createdTime">
                {{ getTime(item.createdTime, "DD/MM/YYYY HH:mm") }}
              </td>
              <td v-if="item.filePath">
                <div
                  @click="downloadFile(item.filePath)"
                  class="download-button"
                >
                  İndir
                </div>
              </td>
              <td v-else>-</td>
            </tr>
          </tbody>
        </table>
      </template>
    </div>
  </div>
</template>

<script>
import { BaseSelect, BaseButton } from "@/components";
import { mapActions } from "vuex";
const ListViewSkeleton = () =>
  import(/* webpackPrefetch: true */ "@/components/base/ListViewSkeleton");

export default {
  name: "ManualReport",
  data() {
    return {
      years: [],
      months: [],
      tableHeaders: [
        { name: "Dosya Adı" },
        { name: "Dosya Boyutu" },
        { name: "Oluşturulduğu Tarih" },
        { name: "Dosya" },
      ],
      reportListData: [],
      formItems: {
        year: 0,
        month: 0,
        dateTime: null,
      },
      stopOverClicks: false,
      polling: null,
      countdownTimer: null,
      pollingInterval: 10000,
      countdown: 10,
      logsLoader: false,
    };
  },
  components: {
    BaseSelect,
    BaseButton,
    ListViewSkeleton,
  },
  methods: {
    ...mapActions([
      "getManuelReportExport",
      "getVdsReportExport",
      "getReportList",
      "postAlgorithmPurchaseExportExcel",
    ]),
    startPolling() {
      this.stopPolling(); // varsa önce temizle

      // İlk liste çekme
      this.getReportItems();

      // Geri sayımı başlat
      this.countdown = this.pollingInterval / 1000;
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        }
      }, 1000);

      // 30 saniyede bir listeyi güncelle
      this.polling = setInterval(() => {
        this.logsLoader = true;
        setTimeout(() => {
          this.getReportItems();
          this.logsLoader = false;
        }, 1000);
        this.countdown = this.pollingInterval / 1000;
      }, this.pollingInterval);
    },
    stopPolling() {
      if (this.polling) {
        clearInterval(this.polling);
        this.polling = null;
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    getCustomerReports() {
      if (this.formItems.year === 0 && this.formItems.month === 0) {
        return this.$toast.warning("Lütfen Ay ve Yıl Seçiniz.");
      }

      this.logsLoader = true;
      this.stopOverClicks = true;
      this.$toast.info("Raporunuz oluşturuluyorken lütfen bekleyiniz.");

      this.startPolling();

      this.getManuelReportExport(this.formItems).then((returnValue) => {
        if (returnValue && !returnValue?.error) {
          this.$toast.success("Manuel Müşteri Raporu başarıyla oluşturuldu.");
        } else {
          this.$toast.error(returnValue.message);
        }
        this.stopOverClicks = false;
      });
    },
    getVdsReports() {
      if (this.formItems.year === 0 && this.formItems.month === 0) {
        return this.$toast.warning("Lütfen Ay ve Yıl Seçiniz.");
      }
      this.stopOverClicks = true;
      this.getVdsReportExport(this.formItems).then((returnValue) => {
        if (returnValue && !returnValue?.error) {
          this.$toast.success("VDS Raporu başarıyla oluşturuldu.");
        } else {
          this.$toast.error(returnValue.message);
        }
        this.stopOverClicks = false;
      });
    },
    getReportItems() {
      this.getReportList().then((response) => {
        if (response) {
          this.reportListData = response;

          this.reportListData.forEach((item) => {
            let fileSize = String(item.fileLength).slice(0, 4);
            item.fileLength = fileSize;
          });
        }
      });
    },
    postAlgorithmExportExcel() {
      if (this.formItems.dateTime == null) {
        this.$toast.error("Lütfen Tarih seçiniz.");
      } else {
        this.stopOverClicks = true;
        let firstDate = this.getTime(this.formItems.dateTime[0]);
        let secondDate = this.getTime(this.formItems.dateTime[1]);
        let mergeTheDates =
          this.splitTimes(firstDate) + "&" + this.splitTimes(secondDate);

        let selectedFilter = {
          DatePeriod: mergeTheDates,
        };
        this.postAlgorithmPurchaseExportExcel({ filter: selectedFilter }).then(
          (response) => {
            if (response) {
              this.getReportItems();
              this.$toast.success("Rapor Başarıyla oluşturuldu.");
            } else {
              this.$toast.error("Rapor oluşturulamadı.");
            }
            this.stopOverClicks = false;
          }
        );
      }
    },
    splitTimes(time) {
      return time.split("T")[0];
    },
    downloadFile(filePath) {
      const createElem = document.createElement("a");
      const setUrls = process.env.VUE_APP_API_URL + "/" + filePath;
      createElem.setAttribute("href", setUrls);
      createElem.click();
    },
    getTime(dateTime, formatType) {
      let stringDateTime = dateTime.toString();
      let generateMomentDate = this.$moment(new Date(stringDateTime)).format(
        formatType
      );
      return generateMomentDate;
    },
  },
  mounted() {
    const monthNames = [
      "Ocak",
      "Şubat",
      "Mart",
      "Nisan",
      "Mayıs",
      "Haziran",
      "Temmuz",
      "Ağustos",
      "Eylül",
      "Ekim",
      "Kasım",
      "Aralık",
    ];
    const date = new Date();
    let currentYear = date.getFullYear();
    for (let i = 0; i < 5; i++) {
      currentYear = i === 0 ? currentYear : currentYear - 1;
      this.years.push({ code: currentYear, label: currentYear });
    }
    for (let i = 0; i < 12; i++) {
      this.months.push({ code: i + 1, label: monthNames[i] });
    }
    this.getReportItems();
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
};
</script>

<style lang="scss" scoped>
.manuel-report {
  padding: 20px;
  display: flex;
  font-size: 14px;
  padding-bottom: 0px;
  &.report-list {
    flex-direction: row;
    flex-wrap: wrap;
    overflow: auto;
    .report-item {
      max-width: 620px;
      margin-bottom: 20px;
      button {
        max-width: 300px;
      }
    }
  }
  &.pb-0 {
    padding-bottom: 0px;
  }
  @media (max-width: 768px) {
    flex-direction: column;
  }
  .report-item {
    margin-right: 10px;

    &.base-form-input {
      padding-top: 15px;
    }

    ::v-deep .mx-icon-calendar,
    ::v-deep .mx-icon-clear {
      margin-top: -8px;
    }
    @media (max-width: 768px) {
      margin-right: 0px;
    }

    &:last-of-type {
      margin-right: 0;
    }
    &.button-container {
      padding: 18px 0;
      .create-btn {
        width: 170px;
        height: 45px;
        font-size: 14px;
        @media (max-width: 768px) {
          width: 100%;
        }
      }
    }
  }
  .table {
    border-collapse: collapse;
    text-indent: 0;
    border-color: inherit;
    min-width: 100%;
    border-radius: var(--radius-second) !important;
    overflow-x: hidden;
    border: solid 1px #e9e9eb;
    background-color: #fff;
    margin: 20px 0;
    overflow-y: visible !important;
    .download-button {
      background-color: var(--color-primary-default);
      color: var(--grayscale-0);
      padding: 5px;
      border: 1px solid var(--color-primary-default);
      border-radius: 5px;

      transition: all 0.2s ease-in;
      cursor: pointer;
      &:hover {
        background-color: var(--grayscale-0);
        color: var(--color-primary-default);
      }
    }
    @media (max-width: 1024px) {
      overflow-x: scroll;
    }
    th,
    td {
      font-size: 14px;
      padding: 18px 12px;
      vertical-align: middle;
      border-top: 1px solid #e8e8e8;
      text-align: center;
    }
    tbody {
      tr td:first-child {
        width: 350px;
      }
    }
  }
}
</style>
<style lang="scss">
.report-item {
  .form-control-label {
    font-size: 12px;
    color: var(--grayscale-70);
    position: relative;
    padding: 0 7px;
    margin-left: 10px;
    z-index: 2;
    top: 10px;
    background: -webkit-linear-gradient(top, #f3f3f4 50%, #ffffff 50%);
  }

  .mb-10 {
    margin-bottom: 10px;
  }
}
.no-click {
  background-color: #c3c3c3;
  pointer-events: none;
  color: #555;
}
</style>
